import { reactive } from 'vue';
import { ContextLoader } from '../shared/models/AbstractContext';
import WorkPreparationClient from './client/WorkPreparationClient';
import WorkPreparationContext from './models/WorkPreparationContext';
import WorkPreparationService from './services/WorkPreparationService';

export const workPreparationLoader = new ContextLoader(async s => {
  const filters = await WorkPreparationService.parseFilters(s);
  const container = await WorkPreparationClient.search(filters);
  return reactive(new WorkPreparationContext(filters, container)) as WorkPreparationContext;
});